(function (seraphic, $, undefined) {
    var currentTemplate = $("#CurrentTemplate").val();
    var iconMinus = '<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 43 43"><g id="Group_1865" data-name="Group 1865" transform="translate(5074 2966)"><g id="Ellipse_99" data-name="Ellipse 99" transform="translate(-5074 -2966)" fill="none" stroke="currentColor" stroke-width="1"><circle cx="21.5" cy="21.5" r="21.5" stroke="none"/><circle cx="21.5" cy="21.5" r="21" fill="none"/></g><line id="Line_393" data-name="Line 393" y2="16" transform="translate(-5045 -2944) rotate(90)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></g></svg>';
    var iconPlus = '<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 43 43"><g id="Group_1866" data-name="Group 1866" transform="translate(5126 2966)"><g id="Ellipse_7" data-name="Ellipse 7" transform="translate(-5126 -2966)" fill="none" stroke="currentColor" stroke-width="1"><circle cx="21.5" cy="21.5" r="21.5" stroke="none"/><circle cx="21.5" cy="21.5" r="21" fill="none"/></g><line id="Line_390" data-name="Line 390" y2="16" transform="translate(-5105 -2952)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line id="Line_391" data-name="Line 391" y2="16" transform="translate(-5097 -2944) rotate(90)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></g></svg>';

	//-----------------------------------------
	// Namespaced Functions
	//-----------------------------------------
    seraphic.init = function() {
		var searchParams = new URLSearchParams(window.location.search);
    }
    
	seraphic.setCookie = function(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
	}
      
    seraphic.getCookie = function(name) {
  		var value = "; " + document.cookie;
  		var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
      	return "";
	}
    
    seraphic.getUrlVars = function()
    {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }
    
    seraphic.displayVariantImages = function(theVariantId) {
      	$(".ProductThumb").each(function(){
        	var thumbsImgSrc = $(this).attr("data-img-src");
        	if (thumbsImgSrc.indexOf(theVariantId) > -1)
          		$(this).css("display","block");
        	else
          		$(this).css("display","none");
      	});
    }

    seraphic.centerSection = function(sectionToCenter) {
        var innerSection = $(sectionToCenter);

        $(".CenteredAccordionWrapper").each(function() {
            var outerHeight = $(this).height();
            var innerHeight = $(this).find(innerSection).height();
            var newTopPadding = innerHeight < outerHeight ? (outerHeight - innerHeight) / 2 : 0;
            //console.log("o: " + outerHeight + " - i: " + innerHeight + " - t: " + newTopPadding);

            $(this).find(innerSection).css("padding-top", newTopPadding + "px");
        });
    }

    //-----------------------------------------
	// On Load/Refresh
	//-----------------------------------------
    $(document).ready(function() {
        //IMPORTANT: custom Seraphic code that populates HdnVariantId is in global.js. It has to run before other code in that file runs.
        
      	seraphic.init();

        const params = new Proxy(new URLSearchParams(window.location.search), {
        	get: (searchParams, prop) => searchParams.get(prop),
        });
      
      	let scrollToAnchor = params.scrollTo;
      
      	if (typeof scrollToAnchor != "undefined")
        {
          	var aTag = $("a[id='"+ scrollToAnchor +"']");

          	if (typeof aTag.offset() != "undefined")
    			$("html,body").animate({scrollTop: aTag.offset().top},'slow');
        }
      
      	$(".Accordion").each(function(){
            if (!$(this).hasClass("NotExpanded"))
        		$(this).find("li").first().find(".AccordionHeader").find(".AccordionControl").html(iconMinus);
        });

        //console.log(currentTemplate);
        //console.log($(window).width());
        //console.log(window.innerWidth);
        //if (($(".CenteredAccordionWrapper").length > 0) && $(window).width() > 767) {
        //    seraphic.centerSection(".CenteredAccordionInner");
        //}
    });

    //-----------------------------------------
	// Events/Watchers
	//-----------------------------------------
    $(".ListMenuItem").click(function() {
        var itemIndex = $(this).attr("data-index");

        $(".ListMenuItem").removeClass("ListMenuItemActive");
        $(this).addClass("ListMenuItemActive");
        $(".MenuDrawerSubmenu").hide();
        $("#ChildMenu-" + itemIndex).show();
    });

	$(document).on("click", ".AccordionHeader", function (e) {
      	e.preventDefault();
      	e.stopPropagation();

      	//$(this).closest(".Accordion").each(function() {
        //	$(this).find(".AccordionBody").slideUp("fast");
		//	$(this).find(".AccordionControl").html(iconPlus);
      	//});

		var accordionControl = $(this).find(".AccordionControl");
		var accordionBody = $(this).closest("li").find(".AccordionBody");

		if (accordionBody.is(":visible")) {
			accordionControl.html(iconPlus);
			accordionBody.slideUp("fast");
		}
		else {
			accordionControl.html(iconMinus);
			accordionBody.slideDown("fast");
		}
	});
  
  	$(document).on("click", ".ProductThumb", function() {
      	var position = $(this).attr("data-position");
    	$("#OwlsProductCarousel").trigger("to.owl.carousel", [position, 1])
  	});
  
    $(document).on("click", ".GoToCartButton", function() {
		window.location.href="/cart/";
    });
  
  	$(document).on("change", "#hdnVariantId", function() {
      	var newVariant = $(this).val();
      	//unhide to reconnect variant dropdown to image carousel and alt images
		//seraphic.displayVariantImages(newVariant);
        return false;
    });
  
  	$(document).on("click", ".ExpandSectionHeader", function() {
    	var thumbs = $(this).parent().find(".HorizontalThumbs");
      	var thumbsIcon = $(this).parent().find(".ExpandSection");
		if (thumbs.is(":visible"))
        {
          	thumbs.hide();
          	thumbsIcon.html(iconPlus);
        }
    	else
        {
          	thumbs.css("display", "flex");
          	thumbsIcon.html(iconMinus);
        }
      	return false;
  	});
  
  	$(document).on("click", ".CoveredVideoSection ul", function() {
        var coveredVideoPreview = $(this).find(".CoveredVideoPreview");

        if (coveredVideoPreview.is(":visible"))
        {
        	coveredVideoPreview.hide();
        	$(this).find(".CoveredVideo").show();
    		$(this).find(".CoveredVideo iframe")[0].src += "&autoplay=1";
        }
    });
  
    $(document).on("click", ".PanelistControl", function() {
        var panelistBio = $(this).siblings(".PanelistBio");
        if (panelistBio.height() == 66) {
            panelistBio.css("height","100%");
            $(this).html(iconMinus);
        }
        else {
            panelistBio.css("height", "66px");
            $(this).html(iconPlus);
        }
    });

    $(document).on("submit", ".CommuneAddToCartForm", function(e) {
        e.preventDefault();

        var upgradeProduct = $("#upgrade-product");
        var variantId = upgradeProduct.is(":checked") ? upgradeProduct.val() : $("#hdnVariantId").val();
        //console.log(variantId);

        window.location.href = "/cart/add/" + variantId;
      
        return false;
    });

    $(document).on("click", ".CopyLinkImg", function() {
      	var copiedLink = $(this).attr("data-link");
        var linkCopied = $(".LinkCopied");
      	navigator.clipboard.writeText(copiedLink);
        if (linkCopied.length > 0)
         	linkCopied.show();
        else
            $(this).find("img").attr("src", '//intelligenceofnature.com/cdn/shop/files/checkmark-icon.png?v=6151873553289335917');
    });

    //used for videos opening in an overlay/modal/dialog/popup
    $(document).on("click", ".HomeConnectionImage", function() {
        var videoId = $(this).attr("data-video-id");
        var videoTitle = $(this).attr("data-video-title");
        var videoTag = "<iframe width=\"100%\" height=\"100%\" src=\"https://www.youtube-nocookie.com/embed/" + videoId + "?controls=1&loop=1&rel=0&mute=0&modestbranding=1&playlist=" + videoId + "&origin=https://intelligenceofnature.com\" rel=\"0\" modestbranding=\"1\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media\" title=\"Rebecca's Natural Food\" frameborder=\"0\" allowfullscreen></iframe>";
        var videoModal = $(".VideoModal");

        $(".VideoModalInner").html(videoTag);
        videoModal.show();
    });

    //used for videos opening on the page that you want to have load on click and play instantly
    $(document).on("click", ".InlineVideoPreview", function() {
        var inlineVideo = $(this).parent().find(".InlineVideo");
        var videoId = $(this).attr("data-video-id");
        var videoTitle = $(this).attr("data-video-title");

        inlineVideo.show();

        var videoTag = "<iframe width=\"100%\" height=\"100%\" src=\"https://www.youtube-nocookie.com/embed/" + videoId + "?controls=1&loop=1&rel=0&mute=0&modestbranding=1&autoplay=1&playlist=" + videoId + "&origin=https://intelligenceofnature.com\" title=\"" + videoTitle + "\" rel=\"0\" modestbranding=\"1\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media\" frameborder=\"0\" allowfullscreen></iframe>";
        inlineVideo.html(videoTag);

      	$(this).parent().find(".InlineVideoPreview").hide();
    });

    $(document).on("click", ".VideoCloseButton, .VideoModal", function() {
        var videoModal = $(".VideoModal");
      
        if (videoModal.is(":visible"))
        {
            $(".VideoModal").hide();
            $(".VideoModalInner").html("");
        }
    });

    $(document).on("click", ".TabBtn", function() {
        var contentTab = $(this).attr("data-content");
        var tabButton = $(this).attr("data-btn");
        var tabGroup = $(this).attr("data-tab-group");

        $("." + tabButton).removeClass("ActiveTab");
        $(this).addClass("ActiveTab");
        $("." + tabGroup).find(".TabContent").hide();
        $("." + contentTab).show();

        return false;
    });

    $(document).on("click", ".ExpandControl", function() {
        var expandSection =  $(this).parent().find(".ExpandSection");

        $(this).hide();
        expandSection.css("display","inline");
        expandSection.find(".CollapseControl").show();
    });

    $(document).on("click", ".CollapseControl", function() {
        var parentParagraph = $(this).parents("p");

        $(this).hide();
        parentParagraph.find(".ExpandSection").hide();
        parentParagraph.find(".ExpandControl").show();
    });

    $(document).on("click", ".ExpandableControl", function() {
        var controlLocation = $(this).attr("data-section");
        var expandText = $(this).attr("data-expand-text");
        var collapseText = $(this).attr("data-collapse-text");
    
        $("." + controlLocation).find(".ExpandableSection").toggle();
    
        //put text toggle here
    });

    $(document).on("keypress", ".ExpandableControl", function (e) {
        var key = e.which;
        if (key == 13) {
            $(this).click();
            return false;  
        }
    });

    $(document).on("click", ".ProductDiscountCodeWrapper", function() {
        var discountCode = $(this).attr("data-code");

        if (discountCode) {
            //console.log(discountCode);
            //save discount code as session cookie
            document.cookie = 'discount_code=""' + discountCode + '""; path=/';
            $(".ProductDiscountText").text("Discount Code Added");

            // Send GET request to "/discount/[discountcode]"
            fetch("/discount/" + discountCode)
            .then(function() {
                //after discount applied, force cart update so discount is visible for anything that calls .cart.json file 
                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ updates: {}, }),
                });
            })
            .catch(function(error) {
                console.error('Error:', error);
            });
        }
    });
} (window.seraphic = window.seraphic || {}, jQuery));
